module.exports = __webpack_public_path__ + "img/ban-white.89efff57.svg";